import { Menu } from "antd";
import { Link } from "react-router-dom";

const { SubMenu, Item } = Menu;

export function RecursiveMenu(data) {
  return data.map(
    ({ key, label, icon, to, click, children = [], visible = true }) => {
      if (!visible) return;

      if (!children?.length) {
        return (
          <Item
            key={key || Math.random()}
            icon={icon}
            style={{ fontSize: 13 }}
            className="capitalize"
          >
            {to ? (
              <Link to={to}>{label}</Link>
            ) : click ? (
              <div onClick={click}>{label}</div>
            ) : (
              <div>{label}</div>
            )}
            {/* onClick */}
          </Item>
        );
      }

      return (
        <SubMenu
          className="capitalize"
          style={{ paddingLeft: 0, fontSize: 13 }}
          key={key || Math.random()}
          title={label}
          icon={icon}
        >
          {RecursiveMenu(children)}
        </SubMenu>
      );
    }
  );
}
